import React from 'react'

import List from './List'
import Item from './Item'

const routes = [
  {
    path: '/',
    exact: true,
    main: () => <List />,
    isProtected: true
  },
  {
    path: `/:id`,
    exact: true,
    main: () => <Item />,
    isProtected: true
  },
]

export default routes
